import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const CTABand = () => (
  <section className="relative overflow-hidden bg-[#F4F7FD] border-t border-slate-200">
    <div className="absolute inset-0 grid-bg" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
      <Reveal>
        <Eyebrow testId="cta-eyebrow">Let's build what's next</Eyebrow>
        <h2 className="mt-6 font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-[#0A1F44] max-w-2xl">
          Your next hire starts with a conversation.
        </h2>
        <p className="mt-5 text-slate-600 text-base md:text-lg max-w-xl leading-relaxed">
          Tell us which role you need to fill, your preferred engagement type and the skills you are
          looking for.
        </p>
        <Link
          to="/contact"
          data-testid="cta-band-contact-btn"
          className="group mt-10 inline-flex items-center gap-2 rounded-full bg-amber-400 text-[#0A1F44] font-semibold px-7 py-3.5 transition-transform duration-200 hover:scale-[1.04] active:scale-95"
        >
          Discuss a role
          <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </Reveal>
    </div>
  </section>
);
